import styled, { css } from 'styled-components/macro'

import { settings } from '../../styled/settings/index';
import { mixins } from '../../styled/mixins/index';

const {
  colors: { color, hexToRGBa },
  mediaqueries: { mobileDown, tabletLandscapeDown, tabletPortraitDown },
  sizing: { fontsize, spacingsize, radiussize },
  shadows: { buttonShadowDefault },
} = settings;

const {
  layout: { centered, centeredContent, pageSection, pageSectionInner },
  typography: { heading1, heading2, heading3, heroDescription },
} = mixins;

export const CalendarPageContainer = styled.section`
  ${pageSection}
  background-color: ${color(`white`)};
  padding-top: ${spacingsize(5)};
`;

export const CalendarPageInnerContainer = styled.div`
  ${pageSectionInner}
`;